// The contents of this file are replaced at the time of the build and the version string will be set to the build tag.

let version_object = {version: '2026.4.7120957'};

export const { version } = version_object;  // jshint ignore: line

export default version_object;
